export default "__VITE_ASSET__Bpfiyp9L__"